import React, { useState, useEffect } from 'react';

// material-ui
import { Box, Card, Grid, Typography, Avatar, Button, Switch } from '@mui/material';

// project imports

import { getVouchers } from 'services/voucherServices';
import moment from 'moment';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import TableComponent from 'components/TopCourtComponents/Table/TableComponent';
import VoucherFilter from './voucherFilter';
import { TypeSelectOption } from 'components/TopCourtComponents/Input/DateRangeFilter';
import { useNavigate } from 'react-router';
import { useDebounce } from 'use-debounce';
import { courtTypeObj } from 'constant/constant';
import { getUrlCourtCode } from 'helper/Court';
import { checkIsSAdmin, isMerchant } from 'helper/Admin';
import VoucherSummary from './voucherSummary';

const initFilter = {
    voucherDateStart: moment().startOf('month').format('YYYY-MM-DDT17:00:00.000'),
    voucherDateEnd: moment().set({ hour: 23, minute: 59, second: 59, millisecond: 59 }).toISOString(),
    voucherDateType: TypeSelectOption[0],
    redeemStartDate: null,
    redeemEndDate: null,
    redeemDateType: TypeSelectOption[0],
    voucherCode: '',
    usedBy: null,
    expiryDateType: TypeSelectOption[0],
    expiryStartDate: null,
    expiryEndDate: null,
    status: null,
    page: 0
}

export default function Vouchers({

}) {
    const [rows, setRows] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [filter, setFilter] = useState(initFilter)
    const navigate = useNavigate()
    const [debounceFilter] = useDebounce(filter, 500)
    const [summary, setSummary] = useState({
        redeemed: 0
    })

    useEffect(() => {
        loadData()
    }, [debounceFilter])

    // useEffect(() => {

    // }, [rows])

    // function GoToPage({ page
    // }) {
    //     const navigate = useNavigate()
    //     navigate(page)
    // }

    const loadData = async () => {
        try {
            let { data, error } = await getVouchers({
                code: filter.voucherCode ? filter.voucherCode : '',
                usedBy: filter.usedBy ? filter.usedBy.value : '',
                voucherDateStart: filter.voucherDateStart ? filter.voucherDateStart : '',
                voucherDateEnd: filter.voucherDateEnd ? filter.voucherDateEnd : '',
                voucherDateType: filter.voucherDateType ? filter.voucherDateType.value : '',
                expiryDateType: filter.expiryDateType ? filter.expiryDateType.value : '',
                expiryDateStart: filter.expiryStartDate ? filter.expiryStartDate : '',
                expiryDateEnd: filter.expiryEndDate ? filter.expiryEndDate : '',
                redeemStartDate: filter.redeemStartDate ? filter.redeemStartDate : '',
                redeemEndDate: filter.redeemEndDate ? filter.redeemEndDate : '',
                redeemDateType: filter.redeemDateType ? filter.redeemDateType.value : '',
                isRedeemed: filter.status ? (filter.status.value == 'true' ? 'false' : 'true') : '',
                page: filter.page,
            });
            if (error) throw error
            if (data) {
                setRows(data.data)
                setTotalData(data.totalData)
                setSummary({ redeemed: data.redeemedVoucher })
            }
        } catch (error) {
            console.log('ini cek error', error)
        }
    }
    const valueCustomator = (row) => {
        return ({
            createdDate: <TCLabel>{moment(row.createdDate).format("DD/MM/YYYY HH:mm:ss")}</TCLabel>,
            code: <TCLabel>{row.voucherCode}</TCLabel>,
            session: <TCLabel>{`${courtTypeObj[row.courtType] ? courtTypeObj[row.courtType] : row.courtType} ${row.session}`}</TCLabel>,
            sessionValidity: <TCLabel>{`Month + ${row.validity ? row.validity : 3}`}</TCLabel>,
            status: <TCLabel>{row.isRedeemed ? "Not Available" : "Available"}</TCLabel>,
            assignedUser: <TCLabel>{row.user ? row.user.name : "-"}</TCLabel>,
            expiryDate: <TCLabel>{moment(row.expiryDate).format("DD/MM/YYYY")}</TCLabel>,
            usedBy: <TCLabel>{(row.redeemDate && row.user) ? row.user.name : "-"}</TCLabel>,
            redeemDate: <TCLabel>{row.redeemDate ? moment(row.redeemDate).format("DD/MM/YYYY HH:mm:ss") : "-"}</TCLabel>,
        })
    }

    const onChangeFilter = (e) => {
        console.log('here e', e)
        setFilter(prev => ({
            ...prev,
            ...e,
            page: 0
        }))
    }

    const onChangePage = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e
        }))
    }

    const clearFilter = () => {
        setFilter(initFilter)
    }

    return (
        <>
            {
                checkIsSAdmin() &&
                <Button sx={{ mb: 2 }} variant="contained" disableElevation onClick={() => {
                    navigate(`/${getUrlCourtCode()}/vouchers/add`)
                }}>Create Voucher</Button>
            }
            <VoucherFilter filter={filter} onChangeFilter={onChangeFilter} clearFilter={clearFilter} />
            <VoucherSummary filter={filter} redeemed={summary.redeemed} />
            <TableComponent
                columns={[
                    { label: "Created Date" },
                    { label: "Voucher Code" },
                    { label: "Session" },
                    { label: "Session Validity" },
                    { label: "Status" },
                    { label: "Assigned User" },
                    { label: "Expiry Date" },
                    { label: "User" },
                    { label: "Redeem Date" },
                ]}
                rows={rows}
                valueCustomator={valueCustomator}
                page={filter.page}
                totalData={totalData}
                pageChange={(e) => {
                    onChangePage({ page: e })
                }}
            />
        </>
    )
}